const menuFn = () => {
  const config = 100;
  const wrapperNav = $('.wrapper-nav');
  const toggleButton = $('.menu__toggle');
  const containerMobile = $('.wrapper-nav .container');
  const navList = $('.menu-items');
  const path = window.location.pathname;
  const menuItem = $('.hamburger');
  let position = 0;

  if (path === '/') {
    $(window).scroll(function () {
      // get current position
      position = $(this).scrollTop();

      /*
      * verifies that the current position is greater than the configured position,
      * if it adds the `nav--fixed` class
      */
      if (position > config) {
        wrapperNav.addClass('nav--fixed');
        wrapperNav.find('.button--outline').removeClass('button--white').addClass('button--default');
      } else {
        wrapperNav.removeClass('nav--fixed');
        wrapperNav.find('.button--outline').removeClass('button--default').addClass('button--white');
      }
    }).scroll();
  }

  toggleButton.on('click', () => {
    menuItem.toggleClass('is-active');

    if (!navList.hasClass('active')) {
      navList.addClass('active');
    } else {
      navList.removeClass('active');
    }
  });

  $(window).resize(() => {
    const windowWidth = window.innerWidth;

    if (windowWidth > 767) {
      navList.removeClass('active');
      toggleButton.removeClass('active');
      containerMobile.removeClass('container--mobile');
      menuItem.removeClass('is-active');
    } else {
      containerMobile.addClass('container--mobile');
    }
  }).resize();
};

export default menuFn;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/common/menuHamburger.js